module.exports = __webpack_public_path__ + "static/media/elss_banner.590c3a35.svg";